<template>
	<Popup
		v-model="selfDisplay"
		title="新增筛选条件"
		confirmBtnText="添加"
		@confirmClick="handlePopupConfirmClick"
	>
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>名称</span>
				<el-input v-model="name" placeholder="名称"></el-input>
			</div>
			
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="name_tip"><i class="b_icon"></i>请输入筛选条件名称</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>所属机构</span>
				<div>
					<VDistpicker :province="addr.provinceName" :city="addr.cityName" :area="addr.areaName" @province="handleAddrProvinceSelect" @city="handleAddrCitySelect" @area="handleAddrAreaSelect"></VDistpicker>
				</div>
				<div class="base_tip"><template v-if="addr_tip"><i class="b_icon"></i>请选择区域</template></div>
				<div>
					<el-select v-model="hospital" placeholder="请先选择区域" style="width: 200px;" @change="handleHospitalSelect">
						<el-option v-for="(v, i) in hospitals" :key="i" :value="v.id" :label="v.name"></el-option>
					</el-select>
					<div class="base_tip"><template v-if="hospital_tip"><i class="b_icon"></i>请选择医院</template></div>
				</div>
			</div>
			
			<div class="base_form_row">
				<span class="b_label">主治医生</span>
				<div>
					<el-select v-model="doctor" placeholder="请先选择医院" style="width: 200px;">
						<el-option :value="0" label="无"></el-option>
						<el-option v-for="(v, i) in doctors" :key="i" :value="v.uid" :label="v.name"></el-option>
					</el-select>
				</div>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label">擅长</span>
				<div class="b_checkbox_group">
					<el-checkbox-group v-model="special">
						<el-checkbox v-for="v in allDisease" :key="v.id" :label="v.id">{{ v.name }}</el-checkbox>
					</el-checkbox-group>
				</div>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label">创建人</span>
				<el-autocomplete
					class="b_inp"
					v-model="creater"
					:fetch-suggestions="queryCreater"
					placeholder="请输入创建人账号"
				></el-autocomplete>
			</div>
		</div>
	</Popup>
</template>

<script>
	import Api from '../../../../../../../api/index.js'
	import { mapState } from 'vuex'
	
	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data () {
			return {
				selfDisplay: false,
				loading: false,
				name: '',
				addr: {
					provinceName: '',
					provinceCode: '',
					cityName: '',
					cityCode: '',
					areaName: '',
					areaCode: ''
				},
				hospital: '',
				hospitals: [],
				doctor: 0,
				doctors: [],
				special: [],
				creater: '',
				creater_uid: '',
				name_tip: false,
				addr_tip: false,
				hospital_tip: false
			}
		},
		computed: {
			...mapState([
				'authInfo',
				'allDisease'
			])
		},
		methods: {
			/************************ @Events *******************************/
			// 点击省份选择
			handleAddrProvinceSelect(data) {
				this.addr.provinceName = data.code ? data.value : '';
				this.addr.provinceCode = data.code ? data.code.slice(0, 3) : '';
			},
			// 点击城市选择
			handleAddrCitySelect(data) {
				this.addr.cityName = data.code ? data.value : '';
				this.addr.cityCode = data.code ? `${ data.code }000000` : '';
			},
			// 点击区域选择
			handleAddrAreaSelect(data) {
				this.addr.areaName = data.code ? data.value : '';
				this.addr.areaCode = data.code ? `${ data.code }000000` : '';
				this.findHospitalByArea();
			},
			// 点击机构选择
			handleHospitalSelect() {
				this.findDoctorByHospital();
			},
			// 点击弹出确定按钮
			handlePopupConfirmClick() {
				if (!this.name.trim()) {
					this.name_tip = true;
					return false;
				} else {
					this.name_tip = false;
				}
				if (!this.addr.areaCode) {
					this.addr_tip = true;
					return false;
				} else {
					this.addr_tip = false;
				}
				if (!this.hospital) {
					this.hospital_tip = true;
					return false;
				} else {
					this.hospital_tip = false;
				}
				this.loading = true;
				if (this.creater) {
					this.checkCreaterExit();
				} else {
					this.addCondition();
				}
			},
			
			/************************ @Function *******************************/
			// 还原数据
			resetData() {
				this.queryInterval && clearTimeout(this.queryInterval);
				this.name = '';
				this.addr = {
					provinceName: this.authInfo.uprovinceName || '',
					provinceCode: this.authInfo.uprovinceCode || '',
					cityName: this.authInfo.ucityName || '',
					cityCode: this.authInfo.ucityCode || '',
					areaName: this.authInfo.uareaName || '',
					areaCode: this.authInfo.uareaCode || ''
				};
				this.hospital = '';
				this.hospitals = [];
				this.doctor = 0;
				this.doctors = [];
				this.special = [];
				this.creater = '';
				this.creater_uid = '';
				this.name_tip = false;
				this.addr_tip = false;
				this.hospital_tip = false;
				this.loading = false;
				this.findHospitalByArea(true);
			},
			// 创建人匹配
			queryCreater(queryString, cb) {
				const that = this;
				if (queryString) {
					that.queryInterval && clearTimeout(that.queryInterval);
					that.queryInterval = setTimeout(() => {
						var results = [];
						var requestData = {
							code: queryString
						};
						Api.findDoctorsByCode(requestData).then((res) => {
							if (res.data.success) {
								res.data.data.forEach(v => {
									results.push({
										value: v.ucode
									});
								});
								cb(results);
							} else {
								cb([]);
							}
						}, () => {
							cb([]);
						});
					}, 300);
				} else {
					cb([]);
				}
			},
			// 根据区域查找对应的医院
			findHospitalByArea(isFirst) {
				const that = this;
				that.loading = true;
				var requestData = {
					uAreaCode: that.addr.areaCode,
					uCategory: 3,
					uCode: that.authInfo.ucode
				};
				Api.findFirmsByArea(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.hospitals = [];
						res.data.data.forEach((v) => {
							that.hospitals.push({
								id: v.uenterpriseId,
								name: v.uenterpriseName
							});
						});
						that.hospital = that.hospitals.length
							? that.hospitals[0].id
							: '';
						that.findDoctorByHospital(isFirst);
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 根据医院查找对应医生
			findDoctorByHospital(isFirst) {
				const that = this;
				that.loading = true;
				const requestData = {
					id: null,
					uenterpriseId: that.hospital
				};
				Api.findDoctorsByForm(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.doctors = [];
						res.data.data.forEach((v) => {
							(isFirst && v.uid == that.authInfo.uid) && (that.doctor = that.authInfo.uid);
							that.doctors.push({
								uid: v.uid,
								hospitalId: v.uenterpriseId,
								name: v.uname
							});
						});
						if (isFirst) {
							if (!that.doctor)
								that.doctor = 0;
						} else {
							that.doctor = 0;
						}
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 根据账号判断创建人是否存在
			checkCreaterExit() {
				const that = this;
				const requestData = {
					uCode: that.creater,
					type: 'b'
				};
				Api.findUserInfo(requestData).then((res) => {
					if (res.data.success && res.data.data) {
						that.creater_uid = res.data.data.uid;
						that.addCondition();
					} else {
						that.loading = false;
						that.$message.error('请输入存在的创建人账号');
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 新增筛选条件
			addCondition() {
				const that = this;
				const requestData = {
					createrId: that.creater_uid,
					diseaseId: that.special.join(','),
					docterId: that.doctor ? that.doctor : null,
					dr: null,
					id: null,
					uareaCode: that.addr.areaCode,
					uareaName: that.addr.areaName,
					ucityCode: that.addr.cityCode,
					ucityName: that.addr.cityName,
					ucreateTime: null,
					uenterpriseId: that.hospital,
					uprovinceCode: that.addr.provinceCode,
					uprovinceName: that.addr.provinceName,
					explains: that.name
				};
				Api.addCustomerCondition(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.selfDisplay = false;
						that.$message.success(res.data.message);
						that.$emit('complete');
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
		},
		watch: {
			display (newValue) {
				this.selfDisplay = newValue;
			},
			selfDisplay (newValue) {
				this.$emit("changeDisplay", newValue);
				if (newValue) {
					this.resetData();
				}
			}
		}
	}
</script>

<style>
</style>
